<template>
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.90731 14.3188L11.5286 5.17778H12.3787L16 14.3188H15.1019L14.1126 11.7842H9.79464L8.80544 14.3188H7.90731ZM1.35838 11.9217L0.770276 11.3336L4.83901 7.24889C4.36491 6.76414 3.8932 6.16753 3.42389 5.45906C2.9546 4.75057 2.60702 4.10281 2.38115 3.51578H3.27928C3.4817 3.98135 3.788 4.51618 4.19818 5.12026C4.60835 5.72433 5.01798 6.23784 5.42708 6.66079C6.15048 5.92675 6.79265 5.12105 7.35357 4.2437C7.9145 3.36635 8.28765 2.56971 8.47304 1.85378H0V1.02278H5.08191V0H5.91291V1.02278H10.9948V1.85378H9.33599C9.08776 2.72313 8.6648 3.64948 8.06711 4.63283C7.46944 5.61619 6.78547 6.4914 6.01518 7.25849L8.12146 9.42229L7.80184 10.2789L5.42708 7.84179L1.35838 11.9217ZM10.0743 11.0331H13.833L11.9536 6.20376L10.0743 11.0331Z"
      fill="#1E264C"
    />
  </svg>
</template>
